import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Toggle.css";
import ravlogo from "../../assets/img/logo1.png";
import organic from "../../assets/img/image.png";
import { useDispatch } from "react-redux";
import { uiAction } from "../../Redux/Slices/uiSlice";
import ButtonGotoDash from "../../Shared/ButtonGotoDash/ButtonGotoDash";
const DashboardToggle = () => {
  const [isEcommerce, setIsEcommerce] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleToggle = () => {
    setIsEcommerce(!isEcommerce);
  };
  const goToDashboard = () => {
    if (isEcommerce) {
      dispatch(uiAction.updateAppType("Ecommerce"));
    } else {
      dispatch(uiAction.updateAppType("Business"));
    }
    navigate("/dashboard", { replace: true });
  };
  return (
    <div className={` ${isEcommerce ? "toggle-page " : "toggle-page "}`}>
      <div className="toggle-card">
        <div className="headingColor title">Select Your Dashboard</div>
        <div className="toggle-switch">
          <input
            type="checkbox"
            id="dashboardToggle"
            checked={isEcommerce}
            onChange={handleToggle}
          />
          <label
            htmlFor="dashboardToggle"
            className={`slider d-flex ${
              isEcommerce ? "justify-content-start" : "justify-content-end"
            }  align-items-center`}
          >
            <span className="icon-wrapper">
              {isEcommerce ? (
                <img className=" w-100" src={organic} alt="" />
              ) : (
                <img className="w-100 rounded-circle" src={ravlogo} alt="" />
              )}
            </span>
            <span
              className={
                isEcommerce
                  ? " ecommerce text-white me-3  fw-bold"
                  : " associate fw-bold  text-white ms-3"
              }
            >
              {isEcommerce ? "Ecommerce" : "Property"} Dashboard
            </span>
          </label>
        </div>
        <ButtonGotoDash
          removeIcon={true}
          className={`${isEcommerce ? "btn btn-org" : "btn btn-property"} `}
          text={"Go to Dashboard"}
          handleClick={goToDashboard}
        />
      </div>
    </div>
  );
};
export default DashboardToggle;
